import { oiDocDigitalGetFile, listOptions, sendDntToDocDigital } from '@/febos/servicios/api/docDigital.api';
import store from '@/store/store';

export const closeModal = ({ commit }, payload) => {
  commit('CLOSE_MODAL', payload);
};

export async function getDocDigitalFiles(_, payload) {
  const response = await oiDocDigitalGetFile(payload);
  return response.data.respuesta;
}

export const sendToDocDigital = async (_, payload) => {
  try {
    store.commit('Dnts/SET_LOADING', true);
    const response = await sendDntToDocDigital(payload);
    await store.commit('Dnts/UPDATE_SEND_TO_DOCDIGITAL', payload.params.febosId);
    store.commit('Modals/CLOSE_MODAL');
    store.commit('Dnts/SET_SUCCESS_MESSAGE', response.data);
    return response.data;
  } finally {
    store.commit('Dnts/SET_LOADING', false);
  }
};

export const fetchOptionsMyEntityDocDigital = async ({ commit }) => {
  commit('SET_LOADING', true);
  commit('SET_LIST', { target: 'entity', value: [] });
  const response = await listOptions({
    params: {
      metodo: 'GET',
      api: '/api/entidades/token/'
    },
    body: {
      params: {}
    }
  });
  commit('SET_LIST', { target: 'entity', value: response.data.respuesta.result });
  commit('SET_LOADING', false);
};

export const fetchOptionsDocDigital = async ({ commit }) => {
  commit('SET_LOADING', true);
  commit('SET_LIST', { target: 'documentType', value: [] });
  commit('SET_LIST', { target: 'entity', value: [] });
  const responseDocumentType = await listOptions({
    params: {
      metodo: 'GET',
      api: '/api/tipos/documentos/'
    },
    body: {
      params: {}
    }
  });
  const responseEntity = await listOptions({
    params: {
      metodo: 'GET',
      api: '/api/entidades/'
    },
    body: {
      params: {}
    }
  });
  commit('SET_LIST', { target: 'documentType', value: responseDocumentType.data.respuesta.result });
  commit('SET_LIST', { target: 'entity', value: responseEntity.data.respuesta.result });
  commit('SET_LOADING', false);
};
